<template>
    <tr>
        <td class="cell-detail">
            <span>{{row.name}}</span>
            <a :href="row.website" target="_blank" class="cell-detail-description">{{row.readableWebsite}}</a>
        </td>
        <td class="cell-detail">
            <span>{{row.street}}</span>
            <span>{{row.country}} - {{row.postcode}} {{row.location}}</span>
        </td>
        <td class="cell-detail">
            <span>{{row.readableCreatedAt}}</span>
        </td>
        <td class="text-right">
            <div class="btn-group">
                <router-link class="btn btn-secondary" title="Bearbeiten" :to="{ name: 'edit-customer', params: { id: row.id } }"><i class="icon mdi mdi-edit"></i></router-link>
            </div>
        </td>
    </tr>
</template>

<script>
    import errorHandler from '../../../../mixins/errorHandler';
    import Customer from '../../../../models/Customer';

    export default {
        mixins: [errorHandler],

        props: {
            row: {
                type: Customer,
                required: true,
            },
        },
    };
</script>
